import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Drawer } from '@mui/material'
import { PostEntityCreationRule } from '@admin/PostEntityCreationRule/PostEntityCreationRule'

export const Route = createFileRoute('/_auth/preferences/entityTypes/$entityTypeId/rules/new')({
  component: RouteComponent,
})

function RouteComponent() {
  const { entityType } = Route.useRouteContext()
  const navigate = useNavigate()

  const handleDrawerClose = () => {
    void navigate({ from: Route.fullPath, to: '..' })
  }

  return (
    <Drawer anchor="right" open onClose={handleDrawerClose}>
      <PostEntityCreationRule entityType={entityType} onClose={handleDrawerClose} />
    </Drawer>
  )
}
